import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { trans } from '@/i18n';
import { msgMaxLength, msgMinLength, msgRequired } from '@/utils';
import { PASSWORD_HALF_WIDTH_PATTERN } from '@/constants/common';

export const schema = yup.object({
  password: yup
    .string()
    .required(msgRequired('resetPassword.password'))
    .min(8, msgMinLength(8, trans('resetPassword.password')))
    .max(20, msgMaxLength(20, trans('resetPassword.password')))
    .matches(PASSWORD_HALF_WIDTH_PATTERN, trans('error.invalidPasswordHalfWidth'))
    .test('blank_field', 'パスワードにスペース（空白文字）は使用できません。', (value) => {
      return value?.includes(' ') ? false : true;
    })
    .default(undefined),
  rePassword: yup
    .string()
    .required(msgRequired('resetPassword.rePassword'))
    .min(8, msgMinLength(8, trans('resetPassword.rePassword')))
    .max(20, msgMaxLength(20, trans('resetPassword.rePassword')))
    .matches(PASSWORD_HALF_WIDTH_PATTERN, trans('error.invalidPasswordHalfWidth'))
    .oneOf([yup.ref('password')], trans('account.rePasswordInvalid'))
    .default(undefined)
    .test('blank_field', 'パスワードにスペース（空白文字）は使用できません。', (value) => {
      return value?.includes(' ') ? false : true;
    }),
});

export const resetPasswordYup = yupResolver(schema);
